/* istanbul ignore next */
const styles = () => ({
  alertTable: {
    '& th:first-child': {
      width: '140px'
    },
    '& th:nth-child(2)': {
      width: '100px'
    }
  }
});

export default styles;
